"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Activity {
    constructor(input) {
        if (input) {
            this.deserialize(input);
        }
    }
    deserialize(input) {
        Object.assign(this, input);
        this.id = input.id || input._id;
        return this;
    }
}
exports.default = Activity;
